import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import { GetTreatmentPlanRecipePatientResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  patient: GetTreatmentPlanRecipePatientResponse
}

export const PrescriptionPersonDetails = ({ patient }: Props) => {
  const { t } = useLocales()

  return (
    <Card>
      <Card title={t('recipes.patient_information')}>
        <Row gutter={[24, 24]}>
          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('common.sime_code')}</Text>
              <Text weight={400}>{patient.simeCode}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('common.tarv_code')}</Text>
              <Text weight={400}>{patient.tarvCode}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('form.idnp')}</Text>
              <Text weight={400}>{patient.idnp}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('form.last_name')}</Text>
              <Text weight={400}>{patient.lastName}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('form.first_name')}</Text>
              <Text weight={400}>{patient.firstName}</Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('form.birth_date')}</Text>
              <Text weight={400}>
                {dayjs(patient.birthDate).format(dayMonthYearFormatWithDot)}
              </Text>
            </Flex>
          </Col>

          <Col span={8}>
            <Flex vertical gap={4}>
              <Text>{t('form.gender')}</Text>
              <Text weight={400}>{t(`form.${patient.gender}`)}</Text>
            </Flex>
          </Col>
        </Row>
      </Card>
    </Card>
  )
}
